<script>
    import * as VueGoogleMaps from 'vue2-google-maps';


    export default {
        name: "Widget",
        components: {
            'vue-google-autocomplete': VueGoogleMaps.Autocomplete,
        },
        props: {
            source: String,
            companyprop: {},
            user: {},
        },
        data() {
            return {
                script: '',
                widget: {
                    type: 'widget_1',
                    width: '66.66%',
                    custom: {
                        color: '#FD6E00',
                        title: ''
                    }
                },
                copy_text: "",
            }
        },
        watch: {
            'widget.type': {
                handler(newValue) {
                    this.script = "";
                    if (newValue == 'widget_1') {
                        this.changeImageClass();
                        this.widget.width = '66.66%';
                    }
                    if (newValue == 'widget_2') {
                        this.changeImageClass();
                        this.widget.width = '50%';
                    }
                    if (newValue == 'widget_3') {
                        this.changeImageClass();
                        this.widget.width = '100%';
                    }
                }
            }
        },
        mounted() {
            window.$(this.$refs.colorpicker).colorpicker()
            window.$(this.$refs.colorpicker)
                .on('focusout.colorpicker', ({ target }) => {
                    this.widget.custom.color = target.value
                })
        },
        methods: {
            composeScript() {
                if (!this.widget.type) {
                    window.toastr.error("Scegli una tipologia di widget");
                } else {
                    let attributes = 'height="600px"';
                    if (this.widget.type === 'widget_3') {
                        attributes = `height="300px" scrolling="no"`;
                    }
                    this.script = `<iframe src="${this.source}?widget_type=${this.widget.type}&color=${encodeURIComponent(this.widget.custom.color)}&title=${this.widget.custom.title}&company_id=${this.companyprop.id}" width="${this.widget.width}" ${attributes}></iframe>`;
                }
            },
            copyText() {
                this.copy_text = $('#iframe_script');
                this.copy_text.select();
                document.execCommand('copy');
                window.toastr.success("Testo copiato con successo");
            },

            getPreview() {
                if (this.widget.type == 'widget_3') {
                    return "/images/widget/widget_horizontal.png";
                }
                return "/images/preview.svg";
            },

            changeImageClass() {
                $('#widget_prewiew').removeClass('widget_1');
                $('#widget_prewiew').removeClass('widget_2');
                $('#widget_prewiew').removeClass('widget_3');
                $('#widget_prewiew').addClass(this.widget.type);
            },
            onPreview() {
                $('html, body').animate({
                    scrollTop: $("#preview").offset().top
                }, 1000);
            },
            createCourse() {
                window.location.href = '/corsi/create/?company=' + this.companyprop.slug;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/company/dashboard/Widget.vue